/**
 * English strings for the Company Settings -> Users overview.
 * Kept out of the main translation file to stay within the size gate.
 */
export const enUsers = {
	title: "Users",
	search: "users",
	languages: {
		label: "Languages",
		tooltipTitle: "Copywriting languages",
		primary: "Primary",
		secondary: "Secondary",
		fallback: "Fallback",
		none: "None",
	},
};
